import { commitMutation, graphql } from 'react-relay';
import environment from '../../../environment';

const mutation = graphql`
  mutation selectFrontSquareBoxByGuestFrontMutation(
    $input: select_front_square_box_by_guest_mutationInput!
  ) {
    selectFrontSquareBoxByGuest(input: $input) {
      code
      message
    }
  }
`;

function selectFrontSquareBoxByGuestFront(data, callback) {
  const variables = {
    input: {
      squaresInput: data,
    },
  };

  commitMutation(environment, {
    mutation,
    variables,
    onCompleted: (response, errors) => {
      callback(response);
    },
    onError: err => console.error(err),
  });
}

export default selectFrontSquareBoxByGuestFront;
